export const referralOptions = [
  { value: 'amazon', label: 'Amazon' },
  { value: 'event_or_conference', label: 'Event or Conference' },
  { value: 'social_media', label: 'Facebook, Instagram, X or TikTok' },
  { value: 'friend_or_family', label: 'Friend or Family' },
  { value: 'google_or_online_search', label: 'Google or Online Search' },
  { value: 'groupon', label: 'Groupon' },
  { value: 'health_food_store', label: 'Health Food Store' },
  { value: 'healthcare_provider', label: 'Healthcare Provider' },
  { value: 'pet_store', label: 'Pet Store' },
  { value: 'returning_customer', label: 'Returning Customer' },
  { value: 'ucari_partner', label: 'UCARI Partner' },
  { value: 'veterinarian', label: 'Veterinarian' },
  { value: 'other', label: 'Other' }
];

export const humanGenderOptions = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'non_binary', label: 'Non-binary' },
  { value: 'self_describe', label: 'Prefer to self-describe' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' }
];

export const humanAgeRangeOptions = [
  { value: 'under_18', label: 'Under 18' },
  { value: '18_24', label: '18–24' },
  { value: '25_34', label: '25–34' },
  { value: '35_44', label: '35–44' },
  { value: '45_54', label: '45–54' },
  { value: '55_64', label: '55–64' },
  { value: '65_74', label: '65–74' },
  { value: '75_plus', label: '75+' }
];

export const petTypeOptions = [
  { value: 'dog', label: 'Dog' },
  { value: 'cat', label: 'Cat' }
];

export function createInitialKitRegistrationForm() {
  return {
    subjectType: 'human',
    firstName: '',
    lastName: '',
    gender: '',
    genderSelfDescribe: '',
    birthMonth: '',
    birthYear: '',
    petName: '',
    petType: '',
    petBreed: '',
    petBreedOther: '',
    petApproximateAge: ''
  };
}

export const dogBreedOptions = [
  'Labrador Retriever',
  'Golden Retriever',
  'German Shepherd',
  'French Bulldog',
  'Bulldog',
  'Poodle',
  'Beagle',
  'Dachshund',
  'Boxer',
  'Yorkshire Terrier',
  'Chihuahua',
  'Shih Tzu',
  'Australian Shepherd',
  'Border Collie',
  'Cavalier King Charles Spaniel',
  'Great Dane',
  'Siberian Husky',
  'Corgi',
  'Mixed Breed (Mixed)',
  'Other / Unknown'
];

export const catBreedOptions = [
  'Domestic Shorthair',
  'Domestic Longhair',
  'Domestic Medium Hair',
  'Siamese',
  'Maine Coon',
  'Persian',
  'Ragdoll',
  'Bengal',
  'Sphynx',
  'British Shorthair',
  'Russian Blue',
  'Abyssinian',
  'Scottish Fold',
  'Birman',
  'Norwegian Forest Cat',
  'Mixed Breed',
  'Other / Unknown'
];

function resolvePetBreedSelection(value, otherValue) {
  const breed = String(value || '').trim();
  const customBreed = String(otherValue || '').trim();

  if (!breed) {
    return {
      petBreedMode: null,
      petBreed: null
    };
  }

  if (breed === 'Mixed Breed (Mixed)' || breed === 'Mixed Breed') {
    return {
      petBreedMode: 'mixed_breed',
      petBreed: null
    };
  }

  if (breed === 'Other / Unknown') {
    if (customBreed) {
      return {
        petBreedMode: 'known',
        petBreed: customBreed
      };
    }

    return {
      petBreedMode: 'unknown',
      petBreed: null
    };
  }

  return {
    petBreedMode: 'known',
    petBreed: breed
  };
}

export function formatMobileNumberInput(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const hasLeadingPlus = raw.startsWith('+');
  const digits = raw.replace(/\D/g, '');
  if (!digits) return hasLeadingPlus ? '+' : '';

  if (!hasLeadingPlus && digits.length <= 10) {
    if (digits.length < 4) return digits;
    if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }

  return `${hasLeadingPlus ? '+' : ''}${digits}`;
}

export function normalizeMobileNumber(value) {
  const raw = String(value || '').trim();
  if (!raw) return { value: null, error: null };

  const hasLeadingPlus = raw.startsWith('+');
  const digits = raw.replace(/\D/g, '');
  if (digits.length < 7 || digits.length > 15) {
    return { value: null, error: 'Enter a valid mobile number.' };
  }

  return {
    value: `${hasLeadingPlus ? '+' : ''}${digits}`,
    error: null
  };
}

export function normalizePostalCode(value) {
  const raw = String(value || '').trim();
  if (!raw) return { value: null, error: null };
  if (raw.length > 20) return { value: null, error: 'Enter a valid ZIP or postal code.' };
  if (!/^[A-Za-z0-9 -]+$/.test(raw)) return { value: null, error: 'Enter a valid ZIP or postal code.' };
  return { value: raw.toUpperCase(), error: null };
}

export function validateRegistrationForm(values) {
  const errors = {};
  const email = String(values.email || '').trim();
  const firstName = String(values.firstName || '').trim();
  const lastName = String(values.lastName || '').trim();
  const password = String(values.password || '');
  const confirmPassword = String(values.confirmPassword || '');
  const mobile = normalizeMobileNumber(values.mobileNumber);
  const postal = normalizePostalCode(values.zipCode);

  if (!email) errors.email = 'Email is required.';
  else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) errors.email = 'Enter a valid email address.';

  if (!firstName) errors.firstName = 'First name is required.';
  if (!lastName) errors.lastName = 'Last name is required.';
  if (!password) errors.password = 'Password is required.';
  if (!confirmPassword) errors.confirmPassword = 'Please confirm your password.';
  if (password && confirmPassword && password !== confirmPassword) errors.confirmPassword = 'Passwords do not match.';
  if (mobile.error) errors.mobileNumber = mobile.error;
  if (postal.error) errors.zipCode = postal.error;
  if (values.referralSource === 'other' && !String(values.referralSourceOther || '').trim()) {
    errors.referralSourceOther = 'Please tell us how you heard about UCARI.';
  }

  return errors;
}

export function validateKitRegistrationForm(values) {
  const errors = {};
  const firstName = String(values.firstName || '').trim();
  const lastName = String(values.lastName || '').trim();
  const subjectType = values.subjectType || 'human';

  if (!firstName) errors.firstName = 'First name is required.';
  if (!lastName) errors.lastName = 'Last name is required.';

  if (subjectType === 'human') {
    if (values.gender === 'self_describe' && !String(values.genderSelfDescribe || '').trim()) {
      errors.genderSelfDescribe = 'Please describe your gender.';
    }

    if (values.birthMonth || values.birthYear) {
      const month = Number(values.birthMonth);
      const year = Number(values.birthYear);
      const currentYear = new Date().getFullYear();
      if (!Number.isInteger(month) || month < 1 || month > 12) errors.birthMonth = 'Select a birth month.';
      if (!Number.isInteger(year) || year < 1900 || year > currentYear) errors.birthYear = 'Enter a valid birth year.';
    }
  }

  if (subjectType === 'pet') {
    if (!String(values.petName || '').trim()) errors.petName = 'Pet name is required.';
    if (!values.petType) errors.petType = 'Pet type is required.';
    else if (!['dog', 'cat'].includes(values.petType)) {
      errors.petType = 'Choose dog or cat.';
    }
  }

  return errors;
}

export function buildRegistrationPayload(values) {
  const mobile = normalizeMobileNumber(values.mobileNumber);
  const postal = normalizePostalCode(values.zipCode);

  return {
    username: String(values.email || '').trim(),
    email: String(values.email || '').trim(),
    firstName: String(values.firstName || '').trim(),
    lastName: String(values.lastName || '').trim(),
    password: values.password,
    mobileNumber: mobile.value,
    zipCode: postal.value,
    referralSource: values.referralSource || null,
    referralSourceOther: values.referralSource === 'other'
      ? String(values.referralSourceOther || '').trim() || null
      : null,
    receiveEducationalEmails: !!values.receiveEducationalEmails
  };
}

export function buildKitRegistrationPayload(values) {
  const payload = {
    kitId: values.kitId,
    subjectType: values.subjectType,
    firstName: String(values.firstName || '').trim(),
    lastName: String(values.lastName || '').trim()
  };

  if (values.subjectType === 'human') {
    payload.gender = values.gender;
    payload.genderSelfDescribe = values.gender === 'self_describe'
      ? String(values.genderSelfDescribe || '').trim()
      : null;
    payload.birthMonth = values.birthMonth ? String(values.birthMonth) : null;
    payload.birthYear = values.birthYear ? String(values.birthYear) : null;
    payload.ageRange = null;
  }

  if (values.subjectType === 'pet') {
    const breedSelection = resolvePetBreedSelection(values.petBreed, values.petBreedOther);

    payload.petName = String(values.petName || '').trim();
    payload.petType = values.petType;
    payload.petTypeOther = null;
    payload.petBreedMode = breedSelection.petBreedMode;
    payload.petBreed = breedSelection.petBreed;
    payload.petApproximateAge = String(values.petApproximateAge || '').trim() || null;
  }

  return payload;
}
